module.exports = __webpack_public_path__ + "images/emoji/slot_machine.f02cd0f479ce4e4259f9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/slot_machine.png
// module id = lSUE
// module chunks = 14